import { mutator } from 'satcheljs';
import { getUserConfiguration } from 'owa-session-store';
import { updateInboxTabsWatermarks } from '../actions/updateInboxTabsWatermarks';

mutator(updateInboxTabsWatermarks, actionMessage => {
    getUserConfiguration().UserOptions.InboxPlusWatermarks = actionMessage.watermarksToWrite;
});
